import { render } from "./gorgias-modal-forms.vue?vue&type=template&id=5c678052"
import script from "./gorgias-modal-forms.vue?vue&type=script&lang=js"
export * from "./gorgias-modal-forms.vue?vue&type=script&lang=js"

import "./gorgias-modal-forms.vue?vue&type=style&index=0&id=5c678052&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__